import { render, staticRenderFns } from "./template_add_or_edit.vue?vue&type=template&id=79250973&scoped=true"
import script from "./template_add_or_edit.vue?vue&type=script&lang=js"
export * from "./template_add_or_edit.vue?vue&type=script&lang=js"
import style0 from "./template_add_or_edit.vue?vue&type=style&index=0&id=79250973&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79250973",
  null
  
)

export default component.exports